import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
} from "../util/Api";
import {
  Loader2,
  MapPin,
  Cake,
  Heart,
  ArrowLeft,
  Crown,
  Star,
  User,
  Menu,
  X,
} from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { ProfileCard } from "./ProfileCard";
import { Header } from "./Header";
import { Helmet } from "react-helmet";
import { setCurrentPage } from "../redux/navigationSlice.js";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { clearUserState } from "../redux/userSlice";
import { TrendingProfilesSlider } from "./Trending-profile-slider.jsx";
import { Footer } from "./Footer.jsx";
import { Toaster } from "react-hot-toast";
import ProfileCardsSkeleton from "./ProfileCardsSkeleton.jsx";
import { useTranslation } from "react-i18next";
import { Sparkles, Funnel, ChevronDown, Calendar } from "lucide-react";
import { motion } from "framer-motion";
import { Popover, Box, Typography } from "@mui/material";
import { setProfileCount } from "../redux/profileCountSlice.js";

// Your icons
import TodayIcon from "@mui/icons-material/CalendarToday";
import WeekIcon from "@mui/icons-material/DateRange";

export default function InterestReceiveList({ onNavigate }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  console.log("id", id);
  var layoutType = "Showall";
  const dispatch = useDispatch();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [profilelistloading, setProfilelistloading] = useState(false);
  const completion = useSelector((state) => state.completion.value);
  const [openCompletionDialog, setOpenCompletionDialog] = useState(false);
  const handleLogout = () => {
    setShowLogoutDialog(true);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // FILTER STATES
  const [open, setOpen] = useState(false);
  const [filterAnchor, setFilterAnchor] = useState(null);
  const [period, setPeriod] = useState("all");

  // OPEN FILTER
  const handleFilterClick = (event) => {
    setFilterAnchor(event.currentTarget);
    setOpen(true);
  };

  // CLOSE FILTER
  const handleFilterClose = () => {
    setOpen(false);
    setFilterAnchor(null);
  };

  // HANDLE DATE FILTER CHANGE
  const handlePeriodChange = (value) => {
    setPeriod(value);
    handleFilterClose();
    // You can filter viewerProfiles here if needed
    console.log("Selected Period:", value);
  };

    const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 500);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, [])


  const [profileData, setprofileData] = useState("");
  const [subpack, setSubsPack] = useState("");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/user-id/get_by_id?user_id=${id}`
        );
        setprofileData(response?.data?.profile?.name);
        setSubsPack(response?.data?.subscription?.plan_name);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    if (id && token) {
      fetchProfile();
    }
  }, [id, token]);

  const [interestList, setInterestList] = useState([]);
  console.log(interestList, "INTERETSLIST");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalInterests, setTotalInterests] = useState(0);

  const [sentInterestIds, setSentInterestIds] = useState([]);
  useEffect(() => {
    const fetchInterests = async () => {
      setProfilelistloading(true);
      if (!token || !id) return;
      try {
        const sentresponse = await getWithTokenAPI(
          token,
          `/interest/get_send_interest?user_id=${id}&period=${period}`
        );
        const receivers = sentresponse?.data?.receivers || [];
        
        if (receivers.length > 0) {
          setSentInterestIds(receivers);
        } else {
          setSentInterestIds([]); // No receivers found
        }
      } catch (error) {
        console.error("Error fetching interests:", error);
        setSentInterestIds([]);
      } finally {
        setProfilelistloading(false);
      }
    };

    fetchInterests();
  }, [token, id, period]);

  useEffect(() => {
    if (!interestList.length) return;
    setInterestList((prevList) =>
      prevList.map((item) => {
        const userId = item?.user_id;
        const isInterested = sentInterestIds.includes(userId);
        return { ...item, interest: isInterested }; // Adds interest: true/false
      })
    );
  }, [sentInterestIds]);

  const getInterests = async () => {
    try {
      setProfilelistloading(true);
      setError(null);

      const response = await getWithTokenAPI(
        token,
        `/interest/get_interest?user_id=${id}`
      );

      console.log("Full Interest API Response:", response);

      if (response?.statusCode === 200) {
        let interestsData = [];

        if (
          response.data &&
          Array.isArray(response.data.interested_user_details)
        ) {
          interestsData = response.data.interested_user_details;
        } else if (Array.isArray(response.data)) {
          interestsData = response.data;
        }

        // ✅ FIX: Check if you've already sent interest back to these profiles
        const interestsWithFlags = interestsData.map((profile) => {
          const userId = profile?.user_id;
          const hasSentInterest = sentInterestIds.map((sentpro)=>{
            return sentpro.user_id === userId; 
          });
          
          return {
            ...profile,
            interest: hasSentInterest, // True if you've sent interest back, false otherwise
          };
        });

        setInterestList(interestsWithFlags);
        setTotalInterests(
          response.data.total_interests || interestsData.length
        );

        console.log("Processed interests:", interestsWithFlags);
      } else if (response?.statusCode === 404) {
        setInterestList([]);
        setTotalInterests(0);
      } else {
        setError(response?.message || t("Failed to fetch interests"));
        setInterestList([]);
        setTotalInterests(0);
      }
    } catch (error) {
      console.error("❌ Error fetching interest data:", error);
      setError(t("Network error: ") + error.message);
      setInterestList([]);
      setTotalInterests(0);
    } finally {
      setProfilelistloading(false);
    }
  };
  useEffect(() => {
    if (id && token && sentInterestIds.length > 0) {
      getInterests();
    }
  }, [id, token, sentInterestIds]); // ✅ Add sentInterestIds as dependency
  const [ShowSubscribeDialog, setShowSubscribeDialog] = useState(false);

  // ---------------- ERROR STATE ----------------
  if (error) {
    return (
      <div className="flex justify-center items-center min-h-[70vh] bg-white rounded-lg border border-gray-200">
        <div className="text-center">
          <div className="text-red-500 text-lg mb-4 mt-6">
            {t("Error:")} {error}
          </div>
          <Button
            onClick={getInterests}
            className="bg-red-500 hover:bg-red-600 text-white mb-6"
          >
            {t("Try Again")}
          </Button>
        </div>
      </div>
    );
  }

  // ---------------- EMPTY STATE ----------------
  if (interestList.length === 0 && !profilelistloading) {
    return (
      <>
        <Toaster position="top-right" />
        <Helmet>
          <title>Avan Aval - Received Interests</title>
          <meta name="description" content="Received interests dashboard" />
        </Helmet>
        <div className="flex justify-center items-center min-h-[70vh] bg-white rounded-lg border border-gray-200">
          <div className="text-center px-4">
            <div className="mb-6 mt-6">
              {/* <div className="w-20 h-20 mx-auto mb-4 bg-red-50 rounded-full flex items-center justify-center">
                <Heart className="h-10 w-10 text-red-500" />
              </div> */}
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t("No Interests Received Yet")}
              </h3>
              <p className="text-gray-600 max-w-md mx-auto">
                {t(
                  "You haven't received any interests yet. When someone shows interest in your profile, they will appear here."
                )}
              </p>
            </div>
            <Button
              onClick={() => navigate("/browse")}
              className="bg-gradient-to-br from-red-500 to-pink-600 text-white cursor-pointer hover:from-red-600 hover:to-pink-700 mb-6"
            >
              {t("Browse Profiles")}
            </Button>
          </div>
        </div>
      </>
    );
  }

  const handleProfileClick = async (profile) => {
    const progress = Math.round((completion / 4) * 100);
    if (!token) return;
    try {
      const profileId = profile?.basicProfile?.user_id || profile?.user_id;
      const profilename = profile?.basicProfile?.name || profile?.name;
      if (!profileId) {
        console.warn("No profile id found for", profile);
        return;
      }
      if (progress > 75) {
        const payload = { viewer_id: id, viewed_id: profileId };
        const response = await postWithTokenAPI(
          token,
          `/profile-view/track`,
          payload
        );
        if (response?.statusCode === 200) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          navigate(`/view-profile/${profilename.replace(/\s+/g, "-")}`, {
            state: { profileId: profileId },
          });
          dispatch(setProfileCount(response?.data?.unique_profiles_viewed_today));
        } else if (response?.statusCode === 403) {
          setShowSubscribeDialog(true);
        } else {
          console.log(response);
        }
      } else {
        setOpenCompletionDialog(true);
      }
    } catch (error) {
      console.error("Error in viewed profile post", error);
    }
  };

  // ---------------- MAIN RENDER ----------------
  return (
    <div className="min-h-[70vh] bg-white rounded-lg border border-gray-200">
      <Toaster position="top-right" />
      <Helmet>
        <title>Avan Aval - Received Interests</title>
        <meta name="description" content="Received interests dashboard" />
      </Helmet>

      {profilelistloading ? (
        <div className="min-h-[70vh] flex items-center justify-center">
          <ProfileCardsSkeleton card={7} />
        </div>
      ) : (
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex justify-between items-center border-b p-4 m-6">
            <div>
              <h3 className="text-2xl font-bold text-gray-900">
                {t("Received Interests")}
              </h3>
              <p className="text-gray-600 mt-1">
                {totalInterests}{" "}
                {totalInterests === 1 ? t("person") : t("people")}{" "}
                {t("shown interest to your profile")}
              </p>
            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleFilterClick}
              className="flex items-center gap-2 px-6 py-3 bg-rose-100 border border-rose-500 rounded-xl text-rose-600 font-semibold hover:shadow-lg transition-all cursor-pointer mt-4 md:mt-0"
            >
              <Funnel size={18} />
              {!isMobile && <span className="inline sm:hidden" >{t("Filter")}</span>}
              <ChevronDown size={16} />
            </motion.button>
          </div>

          <Popover
            open={open}
            anchorEl={filterAnchor}
            onClose={handleFilterClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{
              "& .MuiPopover-paper": {
                borderRadius: "16px",
                boxShadow: "0 20px 40px rgba(225, 29, 72, 0.15)",
                border: "1px solid #fda4af",
                marginTop: "8px",
                minWidth: "220px",
                overflow: "hidden",
              },
            }}
          >
            <Box sx={{ p: 3, backgroundColor: "#fff1f2" }}>
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#e11d48",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 3,
                  fontSize: "14px",
                }}
              >
                <Calendar size={16} />
                {t("Select Period")}
              </Typography>

              {/* Options */}
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {[
                  { value: "today", label: t("Today"), icon: <TodayIcon /> },
                  { value: "week", label: t("This Week"), icon: <WeekIcon /> },
                  {
                                            value: "month",
                                            label: t("This Month"),
                                            icon: <WeekIcon />,
                                          },
                ].map((option) => (
                  <motion.button
                    key={option.value}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => handlePeriodChange(option.value)}
                    className={`flex items-center gap-3 px-4 py-3 rounded-xl border font-semibold
            transition-all cursor-pointer
            ${
              period === option.value
                ? "text-white shadow-lg"
                : "bg-white text-gray-700 border-gray-200 hover:bg-rose-50 hover:text-rose-600"
            }`}
                    style={{
                      background: period === option.value ? "#be123c" : "",
                      borderColor: period === option.value ? "#9f1239" : "",
                    }}
                  >
                    <span>{option.icon}</span>
                    <span>{option.label}</span>
                  </motion.button>
                ))}
              </Box>

              {/* Close Button */}
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleFilterClose}
                className="w-full mt-4 py-3 rounded-xl border border-gray-200 bg-white text-gray-600 font-medium hover:bg-gray-50 cursor-pointer"
              >
                {t("Close")}
              </motion.button>
            </Box>
          </Popover>

          {/* Profiles Slider Section */}
          <div className="min-h-[400px]">
            <TrendingProfilesSlider
              profiles={interestList}
              layoutType="Showall"
              onNavigate={(profile) => {
                const id = profile?.basicProfile?.user_id || profile?.user_id;
                console.log("Clicked profile id:", id);
                handleProfileClick(profile);
              }}
            />
          </div>
        </div>
      )}

      {/* Subscription Dialog */}
      <AlertDialog
        open={ShowSubscribeDialog}
        onOpenChange={setShowSubscribeDialog}
      >
        <AlertDialogContent className="max-w-sm text-center">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-600 text-xl font-semibold">
              🔔 {t("Subscription Required")}
            </AlertDialogTitle>
            <AlertDialogDescription className="text-gray-600 mt-2">
              {t("Upgrade your plan to explore more matches")}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="flex justify-center gap-3 mt-4">
            <AlertDialogCancel
              onClick={() => setShowSubscribeDialog(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                setShowSubscribeDialog(false);
                dispatch(setCurrentPage("subscription"));
              }}
            >
              {t("Subscribe Now")}
            </AlertDialogAction>
          </div>
        </AlertDialogContent>
      </AlertDialog>
      <AlertDialog
        open={openCompletionDialog}
        onOpenChange={setOpenCompletionDialog}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("Your Journey Starts Here")}</AlertDialogTitle>

            <AlertDialogDescription>
              {t(
                "Complete your profile to unlock full access and explore profiles"
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setOpenCompletionDialog(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                setOpenCompletionDialog(false);
                navigate("/profile");
                dispatch(setCurrentPage("profile"));
              }}
            >
              {t("Continue")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
